import { AxiosInstance, AxiosResponse } from 'axios'

import { Proposer } from '../../../domain'
import { withGenericErrorHandling } from '../errors'

export interface PolicyholderClient {
  getProposer: () => Promise<Proposer>
  updateProposer: (policyholder: Partial<Proposer>) => Promise<Proposer>
}

export const createPolicyholderClient = (
  getInstance: () => Promise<AxiosInstance>,
): PolicyholderClient => ({
  getProposer: () =>
    withGenericErrorHandling(async () => {
      const instance = await getInstance()
      const response: AxiosResponse<Proposer> = await instance.get(`/proposer`)
      return response.data
    }),
  updateProposer: (policyholder) =>
    withGenericErrorHandling(async () => {
      const instance = await getInstance()
      const response: AxiosResponse<Proposer> = await instance.patch(
        `/proposer`,
        policyholder,
      )
      return response.data
    }),
})
